import ajax from 'src/ajax'
import get from 'lodash/get'

const API_PATH = `order`

// *********************************
// Actions
// *********************************
const FETCH_PAYMENT_LIST_REQUEST = `FETCH_PAYMENT_LIST_REQUEST`
const FETCH_PAYMENT_LIST_REQUEST_SUCCESS = `FETCH_PAYMENT_LIST_REQUEST_SUCCESS`
const FETCH_PAYMENT_LIST_REQUEST_FAIL = `FETCH_PAYMENT_LIST_REQUEST_FAIL`
// *********************************
// Action Creators
// *********************************
export const fetchPaymentList = (queries) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PAYMENT_LIST_REQUEST })
    const options = { method: 'GET', url: API_PATH, params: queries }
    const response = await ajax(options)
    const list = get(response, 'data.orders', [])
    const total = get(response, 'data.total', 0)
    dispatch({ type: FETCH_PAYMENT_LIST_REQUEST_SUCCESS, payload: { list, total } })
  } catch (error) {
    const code = get(error, 'response.status')
    const text = get(error, 'response.data.message')
    dispatch({ type: FETCH_PAYMENT_LIST_REQUEST_FAIL, payload: `${code} : ${text}` })
  }
}

export const downloadPaymentList = (queries) => async (dispatch) => {
  try {
    // dispatch({ type: FETCH_PAYMENT_LIST_REQUEST })
    const options = { method: 'GET', url: API_PATH + `/invoice`, responseType: 'blob', params: queries }
    const response = await ajax(options)
    const fileURL = URL.createObjectURL(response.data)
    window.open(fileURL)
    // dispatch({ type: FETCH_PAYMENT_LIST_REQUEST_SUCCESS, payload: { list, total } })
  } catch (error) {
    const code = get(error, 'response.status')
    const text = get(error, 'response.data.message')
    dispatch({ type: FETCH_PAYMENT_LIST_REQUEST_FAIL, payload: `${code} : ${text}` })
  }
}

// *********************************
// Reducer
// *********************************
const initialState = {
  fetching: false,
  error: null,
  data: [],
  total: 0,
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_PAYMENT_LIST_REQUEST:
      return { ...state, fetching: true, error: null }
    case FETCH_PAYMENT_LIST_REQUEST_FAIL:
      return { ...state, fetching: false, data: [], total: 0, error: action.payload }
    case FETCH_PAYMENT_LIST_REQUEST_SUCCESS:
      return { ...state, fetching: false, data: action.payload.list, total: action.payload.total }
    default:
      return state
  }
}
